import type { MarketProductsParams } from '~/api/data-source/market-products';
import { marketProductsRepository } from '~/api/repository/market-products';

export const MARKET_PRODUCTS_QUERY_KEY = {
  all: ['market-products'] as const,

  // 마켓 상품 목록 (무한 스크롤, 커서 페이지네이션)
  list: (params: MarketProductsParams) => ({
    queryKey: ['/api/market-place/v3/products', params] as const,
    queryFn: ({ pageParam }: { pageParam?: string[] } = {}) =>
      marketProductsRepository.getMarketProducts({
        ...params,
        searchAfter: pageParam,
      }),
    infinite: true,
  }),

  // 마켓 상품 총 개수
  count: (params: MarketProductsParams) => ({
    queryKey: ['/api/market-place/v3/products/count', params] as const,
    queryFn: () => marketProductsRepository.getMarketProductsCount(params),
  }),
};
